import script from "./task-upload-file.vue?vue&type=script&lang=tsx&setup=true"
export * from "./task-upload-file.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__